module.exports = __webpack_public_path__ + "img/pillow.66592ae7.svg";